// extracted by mini-css-extract-plugin
export default {"pageLoaderWrap":"PageLoader_pageLoaderWrap__29zq+","loader":"PageLoader_loader__9Y21N","spinReverse":"PageLoader_spinReverse__qA4HF"};